import { Injectable } from '@angular/core';
import { Router, RoutesRecognized } from '@angular/router';
export class RouterPathService {
private static _previousRoute: string = '/';
/**
 * @param {?} _router
 */
constructor(private _router: Router) {
    this._router.events
    .filter((e: any) => e instanceof RoutesRecognized)
    .pairwise()
    .subscribe((e: any[]) => {
      RouterPathService._previousRoute = e[0].urlAfterRedirects;
    });
  }
/**
 * @return {?}
 */
getPreviousRoute(): string {
    return RouterPathService._previousRoute;
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Router, },
];
}

function RouterPathService_tsickle_Closure_declarations() {
/** @type {?} */
RouterPathService._previousRoute;
/** @type {?} */
RouterPathService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
RouterPathService.ctorParameters;
/** @type {?} */
RouterPathService.prototype._router;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
